import { apiCall } from './gqlClient';

const EXERCISES_QUERY = `
  query exercises($providerId: Float) {
    exercises(providerId: $providerId)
    {
      id
			providerId
			name
			description
			instructions
			level
			imageId
			videoId
			gifId
			imageUrl
			videoUrl
			gifUrl
			archive
			isPublic
			equipSettings
			useWeights
			sourceId
			ownerId
			isPlatformDefault
			defaultExecutionMode
			defaultExecutionDisplayUnits
			defaultSetSeries
			defaultExecutionMinValue
			defaultExecutionMaxValue
			defaultRestTime
			defaultDeltaValue
			defaultWeight
			defaultDeltaWeight
			defaultWeightMode
      ...fragments
    }
  }`;

export const exercisesApiCall = async ({providerId}, fragments = null) => apiCall({ query: EXERCISES_QUERY, variables: {providerId}, fragments });

const EXERCISE_QUERY = `
  query exercise($id: String!) {
    exercise(id: $id)
    {
      id
			providerId
			name
			description
			instructions
			level
			imageId
			videoId
			gifId
			imageUrl
			videoUrl
			gifUrl
			archive
			isPublic
			equipSettings
			useWeights
			sourceId
			ownerId
			isPlatformDefault
			defaultExecutionMode
			defaultExecutionDisplayUnits
			defaultSetSeries
			defaultExecutionMinValue
			defaultExecutionMaxValue
			defaultRestTime
			defaultDeltaValue
			defaultWeight
			defaultDeltaWeight
			defaultWeightMode
      ...fragments
    }
  }`;

export const exerciseApiCall = async ({id}, fragments = null) => apiCall({ query: EXERCISE_QUERY, variables: {id}, fragments });

const EXERCISEUSAGE_QUERY = `
  query exerciseUsage($id: String!) {
    exerciseUsage(id: $id)
    {
      circuits
			alternatives
			history
      ...fragments
    }
  }`;

export const exerciseUsageApiCall = async ({id}, fragments = null) => apiCall({ query: EXERCISEUSAGE_QUERY, variables: {id}, fragments });

const CREATEEXERCISE_QUERY = `
  mutation createExercise($input: ExerciseInput!) {
    createExercise(input: $input)
    {
      id
			providerId
			name
			description
			instructions
			level
			imageId
			videoId
			gifId
			imageUrl
			videoUrl
			gifUrl
			archive
			isPublic
			equipSettings
			useWeights
			sourceId
			ownerId
			isPlatformDefault
			defaultExecutionMode
			defaultExecutionDisplayUnits
			defaultSetSeries
			defaultExecutionMinValue
			defaultExecutionMaxValue
			defaultRestTime
			defaultDeltaValue
			defaultWeight
			defaultDeltaWeight
			defaultWeightMode
      ...fragments
    }
  }`;

export const createExerciseApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEEXERCISE_QUERY, variables: {input}, fragments });

const UPDATEEXERCISE_QUERY = `
  mutation updateExercise($id: String!, $input: ExerciseInput!) {
    updateExercise(id: $id, input: $input)
    {
      id
			providerId
			name
			description
			instructions
			level
			imageId
			videoId
			gifId
			imageUrl
			videoUrl
			gifUrl
			archive
			isPublic
			equipSettings
			useWeights
			sourceId
			ownerId
			isPlatformDefault
			defaultExecutionMode
			defaultExecutionDisplayUnits
			defaultSetSeries
			defaultExecutionMinValue
			defaultExecutionMaxValue
			defaultRestTime
			defaultDeltaValue
			defaultWeight
			defaultDeltaWeight
			defaultWeightMode
      ...fragments
    }
  }`;

export const updateExerciseApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEEXERCISE_QUERY, variables: {id, input}, fragments });

const DELETEEXERCISE_QUERY = `
  mutation deleteExercise($id: String!) {
    deleteExercise(id: $id)
    {
      id
			providerId
			name
			description
			instructions
			level
			imageId
			videoId
			gifId
			imageUrl
			videoUrl
			gifUrl
			archive
			isPublic
			equipSettings
			useWeights
			sourceId
			ownerId
			isPlatformDefault
			defaultExecutionMode
			defaultExecutionDisplayUnits
			defaultSetSeries
			defaultExecutionMinValue
			defaultExecutionMaxValue
			defaultRestTime
			defaultDeltaValue
			defaultWeight
			defaultDeltaWeight
			defaultWeightMode
      ...fragments
    }
  }`;

export const deleteExerciseApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEEXERCISE_QUERY, variables: {id}, fragments });
